<app-autocomplete-select
  placeholder="{{'search.customer_employees' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
